// proto/v2/usage/usage.proto
//
// Usage + cost queries over WS — Wave 5 HTTP→WS migration. Previously served
// over HTTP at /api/v1/usage/hourly and /api/v1/costs (see
// internal/usage/handler.go). Per-user cost rollups inherit the session
// envelope's encryption on the WS path so the UsageSource backend keys off
// conn.UserID rather than a user_id query param.

// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file usage/usage.proto (package lvdr.v2.usage, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file usage/usage.proto.
 */
export const file_usage_usage: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp]);

/**
 * Token / request counters are int64 (not int32) because a high-volume org
 * on a wide date range can exceed 2.1B tokens per bucket. HTTP used JSON
 * numbers (IEEE-754 double) which implicitly clamped at 2^53 — int64 is the
 * nearest proto equivalent, and JS/TS gets bigint on the wire but Number()
 * is safe for all realistic bucket totals.
 *
 * @generated from message lvdr.v2.usage.HourlyUsageBucket
 */
export type HourlyUsageBucket = Message<"lvdr.v2.usage.HourlyUsageBucket"> & {
  /**
   * @generated from field: google.protobuf.Timestamp hour = 1;
   */
  hour?: Timestamp | undefined;

  /**
   * @generated from field: int64 prompt_tokens = 2;
   */
  promptTokens: bigint;

  /**
   * @generated from field: int64 completion_tokens = 3;
   */
  completionTokens: bigint;

  /**
   * @generated from field: double cost_usd = 4;
   */
  costUsd: number;

  /**
   * @generated from field: int64 requests = 5;
   */
  requests: bigint;
};

/**
 * Describes the message lvdr.v2.usage.HourlyUsageBucket.
 * Use `create(HourlyUsageBucketSchema)` to create a new message.
 */
export const HourlyUsageBucketSchema: GenMessage<HourlyUsageBucket> = /*@__PURE__*/
  messageDesc(file_usage_usage, 0);

/**
 * @generated from message lvdr.v2.usage.UsageTotal
 */
export type UsageTotal = Message<"lvdr.v2.usage.UsageTotal"> & {
  /**
   * @generated from field: int64 prompt_tokens = 1;
   */
  promptTokens: bigint;

  /**
   * @generated from field: int64 completion_tokens = 2;
   */
  completionTokens: bigint;

  /**
   * @generated from field: double cost_usd = 3;
   */
  costUsd: number;

  /**
   * @generated from field: int64 requests = 4;
   */
  requests: bigint;
};

/**
 * Describes the message lvdr.v2.usage.UsageTotal.
 * Use `create(UsageTotalSchema)` to create a new message.
 */
export const UsageTotalSchema: GenMessage<UsageTotal> = /*@__PURE__*/
  messageDesc(file_usage_usage, 1);

/**
 * @generated from message lvdr.v2.usage.CostBucket
 */
export type CostBucket = Message<"lvdr.v2.usage.CostBucket"> & {
  /**
   * @generated from field: google.protobuf.Timestamp hour = 1;
   */
  hour?: Timestamp | undefined;

  /**
   * @generated from field: double cost_usd = 2;
   */
  costUsd: number;

  /**
   * @generated from field: int64 tokens_in = 3;
   */
  tokensIn: bigint;

  /**
   * @generated from field: int64 tokens_out = 4;
   */
  tokensOut: bigint;

  /**
   * @generated from field: int64 requests = 5;
   */
  requests: bigint;
};

/**
 * Describes the message lvdr.v2.usage.CostBucket.
 * Use `create(CostBucketSchema)` to create a new message.
 */
export const CostBucketSchema: GenMessage<CostBucket> = /*@__PURE__*/
  messageDesc(file_usage_usage, 2);

/**
 * @generated from message lvdr.v2.usage.CostGroup
 */
export type CostGroup = Message<"lvdr.v2.usage.CostGroup"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * @generated from field: double cost_usd = 2;
   */
  costUsd: number;

  /**
   * @generated from field: int64 tokens_in = 3;
   */
  tokensIn: bigint;

  /**
   * @generated from field: int64 tokens_out = 4;
   */
  tokensOut: bigint;

  /**
   * @generated from field: int64 requests = 5;
   */
  requests: bigint;
};

/**
 * Describes the message lvdr.v2.usage.CostGroup.
 * Use `create(CostGroupSchema)` to create a new message.
 */
export const CostGroupSchema: GenMessage<CostGroup> = /*@__PURE__*/
  messageDesc(file_usage_usage, 3);

/**
 * @generated from message lvdr.v2.usage.CostTotal
 */
export type CostTotal = Message<"lvdr.v2.usage.CostTotal"> & {
  /**
   * @generated from field: double cost_usd = 1;
   */
  costUsd: number;

  /**
   * @generated from field: int64 tokens_in = 2;
   */
  tokensIn: bigint;

  /**
   * @generated from field: int64 tokens_out = 3;
   */
  tokensOut: bigint;

  /**
   * @generated from field: int64 requests = 4;
   */
  requests: bigint;
};

/**
 * Describes the message lvdr.v2.usage.CostTotal.
 * Use `create(CostTotalSchema)` to create a new message.
 */
export const CostTotalSchema: GenMessage<CostTotal> = /*@__PURE__*/
  messageDesc(file_usage_usage, 4);

/**
 * --- Hourly usage (GET /usage/hourly) ---
 *
 * user_id is NOT on the wire — it comes from conn.UserID. research_id is
 * an optional filter. Missing `from`/`to` default server-side to "last 24h".
 *
 * @generated from message lvdr.v2.usage.GetHourlyUsageRequest
 */
export type GetHourlyUsageRequest = Message<"lvdr.v2.usage.GetHourlyUsageRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: google.protobuf.Timestamp from = 2;
   */
  from?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp to = 3;
   */
  to?: Timestamp | undefined;
};

/**
 * Describes the message lvdr.v2.usage.GetHourlyUsageRequest.
 * Use `create(GetHourlyUsageRequestSchema)` to create a new message.
 */
export const GetHourlyUsageRequestSchema: GenMessage<GetHourlyUsageRequest> = /*@__PURE__*/
  messageDesc(file_usage_usage, 5);

/**
 * @generated from message lvdr.v2.usage.HourlyUsageResponse
 */
export type HourlyUsageResponse = Message<"lvdr.v2.usage.HourlyUsageResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.usage.HourlyUsageBucket buckets = 1;
   */
  buckets: HourlyUsageBucket[];

  /**
   * @generated from field: lvdr.v2.usage.UsageTotal total = 2;
   */
  total?: UsageTotal | undefined;
};

/**
 * Describes the message lvdr.v2.usage.HourlyUsageResponse.
 * Use `create(HourlyUsageResponseSchema)` to create a new message.
 */
export const HourlyUsageResponseSchema: GenMessage<HourlyUsageResponse> = /*@__PURE__*/
  messageDesc(file_usage_usage, 6);

/**
 * --- Hourly costs (GET /costs?group_by=hourly) ---
 *
 * Split into its own message pair (vs. a group_by discriminator) so the
 * response type is unambiguous — HourlyCostsResponse returns buckets,
 * CostsByGroupResponse returns groups. Matches the two-hook split on the
 * frontend (useHourlyCosts / useCostGroups).
 *
 * @generated from message lvdr.v2.usage.GetHourlyCostsRequest
 */
export type GetHourlyCostsRequest = Message<"lvdr.v2.usage.GetHourlyCostsRequest"> & {
  /**
   * @generated from field: google.protobuf.Timestamp from = 1;
   */
  from?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp to = 2;
   */
  to?: Timestamp | undefined;
};

/**
 * Describes the message lvdr.v2.usage.GetHourlyCostsRequest.
 * Use `create(GetHourlyCostsRequestSchema)` to create a new message.
 */
export const GetHourlyCostsRequestSchema: GenMessage<GetHourlyCostsRequest> = /*@__PURE__*/
  messageDesc(file_usage_usage, 7);

/**
 * @generated from message lvdr.v2.usage.HourlyCostsResponse
 */
export type HourlyCostsResponse = Message<"lvdr.v2.usage.HourlyCostsResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.usage.CostBucket buckets = 1;
   */
  buckets: CostBucket[];

  /**
   * @generated from field: lvdr.v2.usage.CostTotal total = 2;
   */
  total?: CostTotal | undefined;
};

/**
 * Describes the message lvdr.v2.usage.HourlyCostsResponse.
 * Use `create(HourlyCostsResponseSchema)` to create a new message.
 */
export const HourlyCostsResponseSchema: GenMessage<HourlyCostsResponse> = /*@__PURE__*/
  messageDesc(file_usage_usage, 8);

/**
 * --- Grouped costs (GET /costs?group_by=research|model|agent) ---
 *
 * @generated from message lvdr.v2.usage.GetCostsByGroupRequest
 */
export type GetCostsByGroupRequest = Message<"lvdr.v2.usage.GetCostsByGroupRequest"> & {
  /**
   * "research" | "model" | "agent"
   *
   * @generated from field: string group_by = 1;
   */
  groupBy: string;

  /**
   * @generated from field: google.protobuf.Timestamp from = 2;
   */
  from?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp to = 3;
   */
  to?: Timestamp | undefined;
};

/**
 * Describes the message lvdr.v2.usage.GetCostsByGroupRequest.
 * Use `create(GetCostsByGroupRequestSchema)` to create a new message.
 */
export const GetCostsByGroupRequestSchema: GenMessage<GetCostsByGroupRequest> = /*@__PURE__*/
  messageDesc(file_usage_usage, 9);

/**
 * @generated from message lvdr.v2.usage.CostsByGroupResponse
 */
export type CostsByGroupResponse = Message<"lvdr.v2.usage.CostsByGroupResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.usage.CostGroup groups = 1;
   */
  groups: CostGroup[];

  /**
   * @generated from field: lvdr.v2.usage.CostTotal total = 2;
   */
  total?: CostTotal | undefined;
};

/**
 * Describes the message lvdr.v2.usage.CostsByGroupResponse.
 * Use `create(CostsByGroupResponseSchema)` to create a new message.
 */
export const CostsByGroupResponseSchema: GenMessage<CostsByGroupResponse> = /*@__PURE__*/
  messageDesc(file_usage_usage, 10);

/**
 * --- Account usage summary (credits + storage) ---
 *
 * Powers the redesigned /usage dashboard hero cards. No org/user on the wire —
 * the org is resolved server-side from conn.UserID. Credit figures are
 * whole-number credits (int64, Number()-safe on the FE); storage is bytes.
 *
 * @generated from message lvdr.v2.usage.GetUsageSummaryRequest
 */
export type GetUsageSummaryRequest = Message<"lvdr.v2.usage.GetUsageSummaryRequest"> & {
};

/**
 * Describes the message lvdr.v2.usage.GetUsageSummaryRequest.
 * Use `create(GetUsageSummaryRequestSchema)` to create a new message.
 */
export const GetUsageSummaryRequestSchema: GenMessage<GetUsageSummaryRequest> = /*@__PURE__*/
  messageDesc(file_usage_usage, 11);

/**
 * @generated from message lvdr.v2.usage.UsageSummaryResponse
 */
export type UsageSummaryResponse = Message<"lvdr.v2.usage.UsageSummaryResponse"> & {
  /**
   * resolved tier name (explorer, researcher, …)
   *
   * @generated from field: string tier = 1;
   */
  tier: string;

  /**
   * spendable now (sum of non-expired batches)
   *
   * @generated from field: int64 credits_balance = 2;
   */
  creditsBalance: bigint;

  /**
   * credits consumed since cycle_start
   *
   * @generated from field: int64 credits_used_cycle = 3;
   */
  creditsUsedCycle: bigint;

  /**
   * tier monthly grant (0 = pay-as-you-go)
   *
   * @generated from field: int64 included_credits = 4;
   */
  includedCredits: bigint;

  /**
   * start of the current billing period
   *
   * @generated from field: google.protobuf.Timestamp cycle_start = 5;
   */
  cycleStart?: Timestamp | undefined;

  /**
   * renewal / anniversary (zero when N/A)
   *
   * @generated from field: google.protobuf.Timestamp cycle_end = 6;
   */
  cycleEnd?: Timestamp | undefined;

  /**
   * measured per-user on-disk footprint
   *
   * @generated from field: int64 storage_used_bytes = 7;
   */
  storageUsedBytes: bigint;

  /**
   * tier StorageGB × 1 GiB; -1 = unlimited
   *
   * @generated from field: int64 storage_limit_bytes = 8;
   */
  storageLimitBytes: bigint;

  /**
   * Pool breakdown — the spendable balance split by expiry semantics so the
   * FE can show "Included: X (renews on D)" vs "Purchased: Y (expires by D)".
   * included_balance + purchased_balance = credits_balance (always; sum is
   * exact, no rounding). Both populated even when one side is zero — the FE
   * hides the empty pool. Expiry timestamps are zero when the pool is empty.
   *
   * remaining in source IN ('included','comp') batches
   *
   * @generated from field: int64 included_balance = 9;
   */
  includedBalance: bigint;

  /**
   * @generated from field: google.protobuf.Timestamp included_expires_at = 10;
   */
  includedExpiresAt?: Timestamp | undefined;

  /**
   * remaining in source='purchase' batches
   *
   * @generated from field: int64 purchased_balance = 11;
   */
  purchasedBalance: bigint;

  /**
   * @generated from field: google.protobuf.Timestamp purchased_expires_at = 12;
   */
  purchasedExpiresAt?: Timestamp | undefined;

  /**
   * Per-batch upcoming expiries + recently-expired events so the FE can show
   * exactly which credits lapse when (not just the soonest per pool) and explain
   * a balance that dropped. active_batches lists every spendable batch with its
   * own expiry; recent_events lists expiries/cancellations in the lookback window.
   *
   * @generated from field: repeated lvdr.v2.usage.CreditBatch active_batches = 13;
   */
  activeBatches: CreditBatch[];

  /**
   * @generated from field: repeated lvdr.v2.usage.CreditExpiryEvent recent_events = 14;
   */
  recentEvents: CreditExpiryEvent[];

  /**
   * BILL-11: bytes of trashed documents excluded from storage_used_bytes (the
   * billed figure = on-disk bytes − trashed bytes, floored at 0).
   *
   * @generated from field: int64 storage_trash_bytes = 15;
   */
  storageTrashBytes: bigint;

  /**
   * BILL-11: first UTC day (YYYY-MM-DD) the billed figure exceeded the gate-tier
   * limit; empty when not over (or unlimited).
   *
   * @generated from field: string storage_over_limit_since = 16;
   */
  storageOverLimitSince: string;

  /**
   * BILL-11b: projected storage overage µcredits from max(today, first chargeable
   * day) to cycle_end at today's excess and price, so non-zero during grace when
   * grace ends inside the cycle; 0 when dormant or on a degraded tier read.
   *
   * @generated from field: int64 storage_overage_projected_micro = 17;
   */
  storageOverageProjectedMicro: bigint;

  /**
   * BILL-11b: first chargeable UTC day (YYYY-MM-DD) of the open overage episode;
   * empty when none or while the price is 0.
   *
   * @generated from field: string storage_overage_charging_from = 18;
   */
  storageOverageChargingFrom: string;
};

/**
 * Describes the message lvdr.v2.usage.UsageSummaryResponse.
 * Use `create(UsageSummaryResponseSchema)` to create a new message.
 */
export const UsageSummaryResponseSchema: GenMessage<UsageSummaryResponse> = /*@__PURE__*/
  messageDesc(file_usage_usage, 12);

/**
 * CreditBatch is one spendable credit batch with its own expiry, so the usage
 * page can warn "6,000 credits expire on D" per-batch rather than collapsing to
 * a single per-pool MIN(expires_at). expires_at unset ⇒ the batch never expires.
 *
 * @generated from message lvdr.v2.usage.CreditBatch
 */
export type CreditBatch = Message<"lvdr.v2.usage.CreditBatch"> & {
  /**
   * credits still spendable in this batch
   *
   * @generated from field: int64 remaining = 1;
   */
  remaining: bigint;

  /**
   * included | comp | purchase | …
   *
   * @generated from field: string source = 2;
   */
  source: string;

  /**
   * unset = never expires
   *
   * @generated from field: google.protobuf.Timestamp expires_at = 3;
   */
  expiresAt?: Timestamp | undefined;
};

/**
 * Describes the message lvdr.v2.usage.CreditBatch.
 * Use `create(CreditBatchSchema)` to create a new message.
 */
export const CreditBatchSchema: GenMessage<CreditBatch> = /*@__PURE__*/
  messageDesc(file_usage_usage, 13);

/**
 * CreditExpiryEvent is a past credit-removal event (expiry / cancellation /
 * clawback) surfaced so a user whose balance dropped sees why. amount is always
 * POSITIVE (the number of credits removed), regardless of the signed ledger row.
 *
 * @generated from message lvdr.v2.usage.CreditExpiryEvent
 */
export type CreditExpiryEvent = Message<"lvdr.v2.usage.CreditExpiryEvent"> & {
  /**
   * expired | cancelled | clawed_back
   *
   * @generated from field: string kind = 1;
   */
  kind: string;

  /**
   * credits removed (always positive)
   *
   * @generated from field: int64 amount = 2;
   */
  amount: bigint;

  /**
   * when it happened (UTC)
   *
   * @generated from field: google.protobuf.Timestamp at = 3;
   */
  at?: Timestamp | undefined;
};

/**
 * Describes the message lvdr.v2.usage.CreditExpiryEvent.
 * Use `create(CreditExpiryEventSchema)` to create a new message.
 */
export const CreditExpiryEventSchema: GenMessage<CreditExpiryEvent> = /*@__PURE__*/
  messageDesc(file_usage_usage, 14);

/**
 * --- Usage history (credits + storage over time) ---
 *
 * Powers the /usage dashboard's two trend charts. No org/user on the wire — the
 * org is resolved from the session and storage is the session user's own.
 *
 * @generated from message lvdr.v2.usage.GetUsageHistoryRequest
 */
export type GetUsageHistoryRequest = Message<"lvdr.v2.usage.GetUsageHistoryRequest"> & {
  /**
   * lookback window; server clamps to [1, 365], default 30
   *
   * @generated from field: int32 days = 1;
   */
  days: number;
};

/**
 * Describes the message lvdr.v2.usage.GetUsageHistoryRequest.
 * Use `create(GetUsageHistoryRequestSchema)` to create a new message.
 */
export const GetUsageHistoryRequestSchema: GenMessage<GetUsageHistoryRequest> = /*@__PURE__*/
  messageDesc(file_usage_usage, 15);

/**
 * One day's data point. credits_used is that day's consumption; storage_bytes is
 * the forward-filled on-disk footprint as of that day (a level, not a delta).
 *
 * @generated from message lvdr.v2.usage.UsageHistoryPoint
 */
export type UsageHistoryPoint = Message<"lvdr.v2.usage.UsageHistoryPoint"> & {
  /**
   * @generated from field: google.protobuf.Timestamp day = 1;
   */
  day?: Timestamp | undefined;

  /**
   * @generated from field: int64 credits_used = 2;
   */
  creditsUsed: bigint;

  /**
   * @generated from field: int64 storage_bytes = 3;
   */
  storageBytes: bigint;
};

/**
 * Describes the message lvdr.v2.usage.UsageHistoryPoint.
 * Use `create(UsageHistoryPointSchema)` to create a new message.
 */
export const UsageHistoryPointSchema: GenMessage<UsageHistoryPoint> = /*@__PURE__*/
  messageDesc(file_usage_usage, 16);

/**
 * @generated from message lvdr.v2.usage.UsageHistoryResponse
 */
export type UsageHistoryResponse = Message<"lvdr.v2.usage.UsageHistoryResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.usage.UsageHistoryPoint points = 1;
   */
  points: UsageHistoryPoint[];
};

/**
 * Describes the message lvdr.v2.usage.UsageHistoryResponse.
 * Use `create(UsageHistoryResponseSchema)` to create a new message.
 */
export const UsageHistoryResponseSchema: GenMessage<UsageHistoryResponse> = /*@__PURE__*/
  messageDesc(file_usage_usage, 17);

/**
 * --- Storage breakdown (where the user's logical storage is allocated) ---
 *
 * Mirrors the credits breakdown: a per-category split of the user's on-disk
 * footprint so the /usage page can show "where your storage went". Bytes are the
 * real allocated footprint (st_blocks). The org/user is resolved from the
 * session. The sum of the categories equals the headline storage_used_bytes.
 *
 * @generated from message lvdr.v2.usage.GetStorageBreakdownRequest
 */
export type GetStorageBreakdownRequest = Message<"lvdr.v2.usage.GetStorageBreakdownRequest"> & {
};

/**
 * Describes the message lvdr.v2.usage.GetStorageBreakdownRequest.
 * Use `create(GetStorageBreakdownRequestSchema)` to create a new message.
 */
export const GetStorageBreakdownRequestSchema: GenMessage<GetStorageBreakdownRequest> = /*@__PURE__*/
  messageDesc(file_usage_usage, 18);

/**
 * @generated from message lvdr.v2.usage.StorageBreakdownResponse
 */
export type StorageBreakdownResponse = Message<"lvdr.v2.usage.StorageBreakdownResponse"> & {
  /**
   * sum of all per-research stores (research/<id>/)
   *
   * @generated from field: int64 research = 1;
   */
  research: bigint;

  /**
   * knowledge.db (per-user promoted nodes + indexes)
   *
   * @generated from field: int64 knowledge = 2;
   */
  knowledge: bigint;

  /**
   * documents.db (uploaded/recording-promoted docs)
   *
   * @generated from field: int64 documents = 3;
   */
  documents: bigint;

  /**
   * encrypted recording blobs
   *
   * @generated from field: int64 recordings = 4;
   */
  recordings: bigint;

  /**
   * notes.db
   *
   * @generated from field: int64 notes = 5;
   */
  notes: bigint;

  /**
   * settings/memory/security/quarantine/voiceprint + misc
   *
   * @generated from field: int64 other = 6;
   */
  other: bigint;

  /**
   * the owner's always-on space island (data/workspaces/<id>), AON-03 D72
   *
   * @generated from field: int64 always_on_space = 7;
   */
  alwaysOnSpace: bigint;
};

/**
 * Describes the message lvdr.v2.usage.StorageBreakdownResponse.
 * Use `create(StorageBreakdownResponseSchema)` to create a new message.
 */
export const StorageBreakdownResponseSchema: GenMessage<StorageBreakdownResponse> = /*@__PURE__*/
  messageDesc(file_usage_usage, 19);

